<script lang="ts">
	import { createEventDispatcher, onMount } from 'svelte'
	import { fade } from 'svelte/transition'
	import { ArrowLeft, Beaker, Bell, DocumentAdd, Icon, Menu, User } from 'svelte-hero-icons'

	import { browser } from '$app/environment'
	import { goto } from '$app/navigation'
	import { page } from '$app/stores'
	import { BUTTON_TYPE } from '$lib/components/Common/Buttons/Button_types'
	import ButtonA from '$lib/components/Common/Buttons/ButtonA.svelte'
	import { CLASS_SIZE } from '$lib/components/Common/ComponentProperties'
	import StatusPill from '$lib/components/Common/StatusPill/StatusPill.svelte'
	import { STATUS_PILL_SIZES } from '$lib/components/Common/StatusPill/StatusPill_types'
	import Tooltip from '$lib/components/Common/Tooltip.svelte'
	import EventList from '$lib/components/Events/List.svelte'
	import Reminders from '$lib/components/Invoice/Reminders.svelte'
	import Badge from '$lib/components/misc/badge.svelte'
	import OpenaiModal from '$lib/components/openai/OpenaiModal.svelte'
	import {
		formatDocStatus,
		formatSaveStatus,
		getDocStatusType,
		SaveStatus
	} from '$lib/functions/formatters'
	import { invoiceSaveStatus as invStatus } from '$lib/semaphores'
	import { estimateSaveStatus as estStatus } from '$lib/semaphores'
	import { account } from '$lib/stores/account/account'
	import { fetchAccountEventsNews, storeEventsNewsCount } from '$lib/stores/account_events_types'
	import { ActiveDialog, dialog } from '$lib/stores/dialog/dialog'
	import { estimate } from '$lib/stores/estimate/estimate'
	import type { EstimateStatus } from '$lib/stores/estimate/types'
	import { uncalculated as invoice } from '$lib/stores/invoice/invoice'
	import { menu_manager } from '$lib/stores/menu'
	import { navChildUrl, navMainUrl, restorePreviousNavLocation } from '$lib/stores/navigation/navigation'
	import { openai_visible_store } from '$lib/stores/openai/openai'
	import {
		AccPlanHasFeatureEnabled,
		Features_Name,
		InitAccSubPlanFeatures
	} from '$lib/stores/subscription_acc_plan_features/subscription_acc_plan_features'
	import { UserActionEnabled, UserActionEnabledSync } from '$lib/stores/user/manager'
	import { user_store } from '$lib/stores/user/user'
	import { InvoiceStatus } from '$lib/types'

    import Breadcrumbs from '../Breadcrumbs.svelte'
			

	const dispatch = createEventDispatcher()

	let titleText = ''
	// let remindersText = ''


	let displayReminders = false
	let remindersDisabled = false
	let eventListToggle = false
	let featureNotification_Viewed_enabled = false
	let featureAIassistant_enabled = false

	let showNewEstimate = false
	let showNewInvoice = false
    let showAiAssistant = false
	
	let statusPillStatus: EstimateStatus | InvoiceStatus = InvoiceStatus.Draft
	let statusPillText = ''
	let editUserEnabled = false
	let editUserLabel = ''

	$: tooltipNotifications = !featureNotification_Viewed_enabled ? 'Upgrade to turn on' : 'Notifications'
	$: tooltipAIassistant = !featureAIassistant_enabled ? 'Upgrade to turn on' : 'AI Assistant'
	$: editUserLabel = editUserEnabled ? 'Edit logged in user' : ''


	// $: console.log('$invoice.status:', $invoice.status)

	let saveStatus: SaveStatus
	$: {
		if ($invStatus === SaveStatus.Saving || $estStatus === SaveStatus.Saving) {
			saveStatus = SaveStatus.Saving
		} else if ($invStatus === SaveStatus.Saved || $estStatus === SaveStatus.Saved) {
			saveStatus = SaveStatus.Saved
		} else {
			saveStatus = SaveStatus.Draft
		}
	}

	$: {
		if (browser) {
			const path = $page.url.pathname
			if (
				path.startsWith('/estimates/new') ||
				path.startsWith('/estimates/edit') ||
				path.startsWith('/estimates/copy')
			) {
				titleText = 'Estimate ' + $estimate.estimateInfo.number
				statusPillStatus = $estimate.estimateInfo.status
			} else if (
				path.startsWith('/invoices/new') ||
				path.startsWith('/invoices/edit') ||
				path.startsWith('/invoices/copy')
			) {
				titleText = 'Invoice ' + $invoice.number
				statusPillStatus = $invoice.status
				// remindersText = 'Reminders are being sent for this invoice.'
				displayReminders = true
				remindersDisabled = !UserActionEnabledSync('$.invoices.view.edit', $user_store)
			} else if (path.includes('/styles')) {
				titleText = 'Invoice 01001'
				statusPillStatus = InvoiceStatus.Sent
			} else titleText = ''
			statusPillText = formatDocStatus(statusPillStatus)

			// showNewInvoice = path === '/invoices' || path === '/invoices/' || path.startsWith('/invoices/edit')
			// showNewEstimate = path === '/estimates' || path === '/estimates/' || path.startsWith('/estimates/edit')
			showNewInvoice = path.startsWith('/invoices') && 
				!path.startsWith('/invoices/new') &&
				!path.startsWith('/invoices/templates')
			showNewEstimate = path.startsWith('/estimates') && 
				!path.startsWith('/estimates/new') &&
				!path.startsWith('/estimates/templates')

		}
	}

	$: displayText = titleText !== ''


	onMount(async () => {
		// Check if Plan of user has featured enabled
		await InitAccSubPlanFeatures()
		featureNotification_Viewed_enabled = AccPlanHasFeatureEnabled(Features_Name.Notification_Viewed)
		featureAIassistant_enabled = AccPlanHasFeatureEnabled(Features_Name.AI_Assistant)	

		fetchAccountEventsNews()
		showAiAssistant = await UserActionEnabled('$.ai_assistant.view')
		
		editUserEnabled = await UserActionEnabled('$.users.view.edit')
	})

	function handleNewInvoice() {
		menu_manager.goNewInvoice()
	}

	function handleNewEstimate() {
		menu_manager.goNewEstimate()
	}

	function handleReturnOrigin() {
		// goto($navUrl)
		// $navUrl = ''
		restorePreviousNavLocation()
	}

	function handleToggleMenu() {
		// menuToggled = !menuToggled
		dispatch('toggle_menu')
	}

	function handleSubscribe() {
		// They want to subscribe
		if (!$account.registered) {
			//goto('/signup?next=/?subscribe');
			goto('/signup')
		} else {
			$dialog = ActiveDialog.Subscribe
		}
	}

	function handleToggleOpenai() {
		if (!featureAIassistant_enabled) {
			handleSubscribe()
			return
		}
		$openai_visible_store = !$openai_visible_store
	}

	function handleToggleEventList() {
		if (!featureNotification_Viewed_enabled) {
			handleSubscribe()
			return
		}
		eventListToggle = !eventListToggle
	}

	const showBackButton = (): boolean => {
		const path = $page.url.pathname

		if (path == $navMainUrl || path == $navChildUrl ) return false
		
		if ((path.includes('templates') ||
		     path.includes('clientShippingLocations') ||
			 thePathIncludeButNotEnd(path, '/clients/') ||
			 thePathIncludeButNotEnd(path, '/items/') ||
			 thePathIncludeButNotEnd(path, '/taxes/') ||
			 thePathIncludeButNotEnd(path, '/categories/') ||
			 thePathIncludeButNotEnd(path, '/expenses_categories/') ||
			 thePathIncludeButNotEnd(path, '/expenses/'))
			 && $navMainUrl != '') {
			return true
		}
		// if (path.includes('templates') && $navUrl != '') {
		// 	return true
		// }
		return false
	}

	function thePathIncludeButNotEnd(thePath:string, contain:string) : boolean
	{
		if (!thePath.includes(contain)) return false

		if (thePath.endsWith(contain)) return false

		if (contain.endsWith('/')) {
			contain = contain.substring(0, contain.length-1)
		}

		if (thePath.endsWith(contain)) return false
		
		return true
	}

	async function handleUserEdit() {
		// const enabled = await UserActionEnabled('$.users.view.edit')
		if (editUserEnabled) {
			goto('/users/user/edit/'+$user_store.id)
		}
	}
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- <div class="menu-overlay" class:menu-toggled={menuToggled} on:click={handleToggleMenu} /> -->
<!-- <MenuLeft bind:menuToggled /> -->
<header class="header w-full ">
	
	<div class="container_grid">
		<div class="img">
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<img
				src="/mobile-logo-new.svg"
				on:click={() => goto('/')}
				width="181px"
				alt="Invoicer.ai"
				class="img-lg hidden cursor-pointer"
			/>
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<img
				src="/simple-logo.svg"
				on:click={() => goto('/')}
				width="33px"
				alt="Invoicer.ai"
				class="img-sm cursor-pointer"
			/>
		</div>

		<div class="main">
			<Breadcrumbs />
			{#if displayText}
				<div class="titleDiv">
					<div class="titleText" data-test-id="layout-menu_text-logo">{titleText}</div>
				</div>
				<StatusPill
					data-test-id="doc_status_pill"
					type={getDocStatusType(statusPillStatus)}
					size={STATUS_PILL_SIZES.SM}
					text={formatDocStatus(statusPillStatus)}
				/>
				<!-- Saving / Save label -->
				{#if saveStatus != SaveStatus.Draft}
					<div
						in:fade
						class=""
						class:text-red-500={saveStatus === 'error'}
						class:text-gray-500={saveStatus !== 'error'}
					>
						<!-- {$semaphores.total} -->
						<!-- {$invStatus} -->
						<span class="font-bold">{formatSaveStatus(saveStatus)}</span>
					</div>
				{/if}
			{/if}
			{#if showBackButton()}
				<div class="btnBackL">
					<ButtonA classSize={CLASS_SIZE.SM} on:click={handleReturnOrigin}>
						<Icon src={ArrowLeft} class="w-5 h-5" />
						Back
					</ButtonA>
				</div>
			{/if}
		</div>

		<div class="btn-r">
			{#if showBackButton()}
				<div class="btnBackR">
					<ButtonA classSize={CLASS_SIZE.SM} on:click={handleReturnOrigin}>
						<Icon src={ArrowLeft} class="w-5 h-5" />
						Back
					</ButtonA>
				</div>
			{/if}
			{#if showNewInvoice}
				<ButtonA type={BUTTON_TYPE.PRIMARY} 
					permission='$.invoices.view.edit'
					data-test-id="new_invoice"
					classSize={CLASS_SIZE.SM} 
					on:click={handleNewInvoice}>
					<Icon src={DocumentAdd} class="w-6 h-6" />
					New Invoice
				</ButtonA>
			{/if}
			{#if showNewEstimate}
				<ButtonA type={BUTTON_TYPE.PRIMARY} 
					permission='$.estimates.view.edit'
					data-test-id="new_estimate"
					classSize={CLASS_SIZE.SM} 
					on:click={handleNewEstimate}>
					<Icon src={DocumentAdd} class="w-6 h-6" />
					New Estimate
				</ButtonA>
			{/if}
			
			<!-- USER INFO -->
			{#if $user_store.email}
				<div class="header-item"
					on:click={handleUserEdit}
				>
					<Tooltip text={editUserLabel} class="top-14" position="bottom">
						<Icon src={User} class="w-8 h-8 p-1" />
						<div class="user-info-text">
							<div><strong>{$user_store.name || $user_store.email}</strong></div>
							<!-- <div>{$user_store.email}</div> -->
							<!-- <div>({$user_store.account_role_name})</div> -->
						</div>
					</Tooltip>
				</div>

			{/if}

			<!-- AI ASSISTANT -->
			{#if showAiAssistant}
				<div class="header-item" on:click={handleToggleOpenai}>
					<Tooltip text={tooltipAIassistant} class="top-12" position="bottom">
						<Icon src={Beaker} solid={false} class="w-8 h-8 p-1" />
					</Tooltip>
				</div>
				<OpenaiModal bind:visible={$openai_visible_store} />
			{/if}


			<!-- NOTIFICATIONS -->
			{#if $account.notifications_enabled}
				<div class="header-item" on:click={handleToggleEventList}>
					<Tooltip text={tooltipNotifications} class="top-12" position="bottom">
						<Icon src={Bell} class="w-8 h-8 p-1" />
						<Badge data-test-id="events-news-count" count={$storeEventsNewsCount} />
					</Tooltip>
				</div>
				<EventList bind:visible={eventListToggle} />
			{/if}
		</div>

		<div class="menu">
			<!-- svelte-ignore a11y-click-events-have-key-events -->
			<div on:click={handleToggleMenu}>
				<Icon src={Menu} class="w-8 h-8 p-1 text-gray-600 cursor-pointer" />
			</div>
		</div>
	</div>
	{#if displayReminders}
		<Reminders disabled={remindersDisabled} />
	{/if}
</header>
<hr class="w-full" />

<style lang="postcss">
	.header {
		display: flex;
		flex-direction: column;
		/* padding: 16px 0px 8px 0px; */
		max-width: 1216px;
		padding: 1rem;
	}
	@media (width >= 414px) {
		.img-lg {
			display: block;
		}
		.img-sm {
			display: none;
		}
	}

	.container_grid {
		/* border: 4px solid lightgray; */
		display: grid;
		grid-template-columns: repeat(2, auto) 32px;
		grid-template-areas:
			'img btn-r menu'
			'main main main';

		/* grid-auto-rows: 56px; */
		/* grid-template-rows: 56px; */
		gap: 16px;
		padding: 0px 8px;

		width: 100%;
		align-items: center;
	}

	/* Tailwindcss MD */
	@media (width >= 768px) {
		.container_grid {
			grid-template-columns: repeat(2, auto);
			grid-template-areas: 'main btn-r';
		}
		.container_grid .img {
			display: none;
		}
		.container_grid .menu {
			display: none;
		}
	}

	.container_grid .img {
		grid-area: img;
	}
	.container_grid .main {
		grid-area: main;
		display: flex;
		gap: 8px;
		align-items: center;
		/* padding-left: 8px; */
		min-width: 0; /* avoid overflow the container */
	}
	.container_grid .btn-r {
		grid-area: btn-r;
		display: flex;
		gap: 8px;
		justify-self: end;
		align-items: center;
	}

	.container_grid .menu {
		grid-area: menu;
		justify-self: end;
	}

	/* title text: Invoice INV-01000 */
	.container_grid .main .titleDiv {
		display: flex;
		align-items: center;
		/* height: 56px; */
		overflow: hidden; /* make sure it hides the content that overflows */
	}
	.container_grid .main .titleText {
		overflow: hidden; /* make sure it hides the content that overflows */
		text-overflow: ellipsis;

		font-size: 24px;
		font-style: normal;
		font-weight: 500;
		line-height: normal;
		white-space: nowrap;
		@apply text-neutral-800;
		/* background-color: yellow; */
	}

	/* manage back button */
	@media (width >= 768px) {
		.container_grid .main .btnBackL {
			display: flex;
		}
		.container_grid .btn-r .btnBackR {
			display: none;
		}
	}
	@media (width < 768px) {
		.container_grid .main .btnBackL {
			display: none;
		}
		.container_grid .btn-r .btnBackR {
			display: block;
		}
	}




	.header-item {
		@apply text-gray-500;
		&:hover {
			@apply text-gray-700;
			cursor: pointer;
		}
	}

	.user-info-text {
		/* display: flex; */
		flex-direction: column;
		display: none;
		font-size: 0.875rem;
	}
	@media (min-width: 640px) {
		.user-info-text {
			display: flex;
		}
	}
</style>
